module.exports = __webpack_public_path__ + "static/media/loginpic1.0f5b45c1.jpg";